import type { Money } from "./types";
import { formatMoney } from "./money";

export type BuyerPaymentSummaryLine = {
  id: string;
  label: string;
  amount: Money;
  emphasis?: boolean;
};

export type BuyerPaymentSummary = {
  lines: BuyerPaymentSummaryLine[];
  totalLabel: string;
  total: Money;
  feeDisclaimer: string;
};

/** Closinglock-style amount breakdown without platform fees or in-app transfer. */
export function buildBuyerPaymentSummary(input: {
  purpose: string;
  amountDue: Money;
}): BuyerPaymentSummary {
  const { purpose, amountDue } = input;
  return {
    lines: [
      { id: "payment", label: purpose, amount: amountDue, emphasis: true },
      {
        id: "wire_fee",
        label: "Wire fee (your bank)",
        amount: { amountCents: 0, currency: "USD" },
        emphasis: false
      },
      {
        id: "platform_fee",
        label: "Veto platform fee",
        amount: { amountCents: 0, currency: "USD" },
        emphasis: false
      }
    ],
    totalLabel: "Amount to send from your bank",
    total: amountDue,
    feeDisclaimer: `No charge through Veto. You send ${formatMoney(amountDue)} from your bank app or branch using the office's wire instructions. Your bank may charge its own wire fee.`
  };
}
